import React, { useContext, useEffect, useState } from 'react'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import Button from 'Components/button'
import { ConcernInfo, CarInfo } from './index'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { GlobalStoreContext } from 'Components/store'
import { getLoginHref } from 'lib/get-login-href'

const plus_icon = require('../../public/static/plus.png')

interface IProps {
  concern_info: ConcernInfo
  car_info: CarInfo
  name: string
  desc: string
  motor_id: number
}
export default function HeaderInfo({ concern_info, car_info, desc }: IProps) {
  const verified_drivers = 0
  const post_num = 0
  const {
    joined_days,
    has_master,
    master_info: {
      avatar_url: community_owner_avatar,
      user_id: master_user_id,
    },
    sign_count,
    show_join_button,
    is_concern,
    user_amount,
    concern_user_info,
  } = concern_info
  const {
    car_id_type,
    series_id,
    image_url,
    motor_id,
    motor_name,
    motor_type,
  } = car_info
  const { user_avatar_list } = concern_user_info
  const [isConcern, setIsConcern] = useState(is_concern)
  const [joinedDays, setJoinedDays] = useState(joined_days)
  const [avatarList, setAvatarList] = useState(
    user_avatar_list.slice(0, 3).map(item => item.avatar_url)
  )
  const { state: globalState } = useContext(GlobalStoreContext)
  const [verified_owner_amount, setVerifiedOwnerAmount] = useState(0)
  const [isJoining, setJoining] = useState(false)
  useEffect(() => {
    fetch(
      `/motor/discuss_ugc/cheyou_community_fans_list/v1/?motor_id=${motor_id}&cursor=0&verify_status=2`
    )
      .then(res => res.json())
      .then(json => {
        setVerifiedOwnerAmount(json.data?.total_follow_count || 0)
      })
  }, [motor_id])

  const mockJoinSuccess = () => {
    setIsConcern(1)
    setJoinedDays('1')
    const avatar_url = globalState?.userData?.avatar_url
    if (!avatar_url) return
    setAvatarList([avatar_url, ...avatarList].slice(0, 3))
  }

  const handleJoinClick = () => {
    if (isConcern) return
    setJoining(true)
    sendTeaCommEvent('click_ugc_forum_home_join', {
      motor_id,
      motor_name,
      motor_type,
    })
    const user_id = globalState?.userData?.user_id
    if (!user_id) {
      window.location.href = getLoginHref()
      setJoining(false)
      return
    }
    const params = {
      car_id: series_id,
      car_id_type,
    }
    fetch('/motor/garage/relation/follow_car/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: serializeObject(params),
      credentials: 'include',
    })
      .then(res => res.json())
      .then(res => {
        if (res.data?.joined_days === 1) {
          mockJoinSuccess()
        } else {
          //
        }
        setJoining(false)
      })
      .catch(err => {
        console.log(err)
        setJoining(false)
      })
  }

  return (
    <div className="header-info">
      <img src={image_url} className="cover" />
      <div className="detail">
        <div className="first-line">
          <h1 className="community-name">{motor_name}</h1>
          {verified_owner_amount > 0 && (
            <span className="verified-drivers">
              <span className="shallow-text">认证车主:</span>
              <span className="dark-text">{verified_owner_amount}</span>
            </span>
          )}
          {/* <span className="posts">
            <span className="shallow-text">帖子:</span>
            <span className="dark-text">{post_num}</span>
          </span> */}
        </div>
        <div className="second-line">
          {has_master && (
            <>
              圈主
              <a
                href={`/user/ugc_profile/${master_user_id}`}
                target="_blank"
                rel="noreferrer noopener"
                className="community-owner-avatar"
              />
            </>
          )}

          <div className="avatar-list">
            {avatarList.map((item, index) => (
              <div
                key={index}
                className="avatar-item"
                style={{
                  backgroundImage: `url(${item})`,
                  left: `-${index * 4}px`,
                  zIndex: 3 - index,
                }}
              />
            ))}
            <div className="avatar-item more-icon">···</div>
            <span className="user-amount">等{user_amount}个车友</span>
          </div>
        </div>
        <div className="description">{desc}</div>
      </div>

      <Button
        type="new_primary"
        className="join-btn"
        onClick={handleJoinClick}
        disabled={!!isConcern}
        loading={isJoining}
      >
        {!isConcern && <img src={plus_icon} className="plus-icon" />}
        {isConcern ? `已加入${joinedDays}天` : '加入'}
      </Button>

      <style jsx>
        {`
        .header-info{
          width: 800px;
          height: 138px;
          padding: 16px 24px 16px 16px;
          border-radius: 2px;
          background-color: white;
          display: flex;
          align-items: center;
          position: relative;
          margin-bottom: 40px;
        }  

        .cover{
          width: 160px;
          height: 106px;
          object-fit: cover;
          object-position: center;
          margin-right: 16px;
        }

        .detail{
          height: 106px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .first-line{
          height: 36px;
          display: flex;
          align-items: center;
        }

        .community-name{
          color: #1f2129;
          font-size: 24px;
          line-height: 1.5;
          margin-right: 8px;
        }

        .verified-drivers, .posts{
          font-size: 12px;
          line-height: 1.5px;
          margin-right: 16px;
        }

        .shallow-text{
          color: #979aa8;
          margin-right: 8px;
        }

        .dark-text{
          color: #1f2129;
          font-family: D-DINExp;
        }

        .second-line{
          height: 32px;
          display: flex;
          align-items: center;
          font-size: 12px;
          line-height: 1.5px;
          color: #979aa8;
        }
        .community-owner-avatar{
          margin-left: 4px;
          margin-right: 16px;
          width: 32px;
          height: 32px;
          background-image: url("${community_owner_avatar}");
          background-position: center;
          background-size: contain;
          border-radius: 50%;
        }

        .avatar-list {
          display: flex;
          align-items: center;
        }
        .avatar-item {
          position: relative;
          width: 16px;
          height: 16px;
          background-size: 100%;
          border-radius: 50%;
        }
        .more-icon {
          left: -13px;
          line-height: 16px;
          background-color: #e6e6e6;
          text-align: center;
          letter-spacing: -2px;
        }
        .user-amount {
          position: relative;
          left: -6px;
        }

        .description{
          color: #1f2129;
          font-size: 12px;
          line-height: 1.5;
        }
        :global(.header-info .join-btn){
          height: 28px;
          position: absolute;
          top: 20px;
          right: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 4px 10px;
        }
        .plus-icon{
          margin-right: 2px;
          width: 16px;
          height: 16px;
          object-fit: cover;
          object-position: center;
        }
      `}
      </style>
    </div>
  )
}
